import { createSlice, current } from "@reduxjs/toolkit";

const defaultConfigProvisionings = [
  {
    "seriesName": "DAP-E9560/A",
    "capabilities": {
      "env": "indoor",
      "ipv4Conf": true,
      "ipv6Conf": false,
      "linkSpeed": [
        {
          "count": 16,
          "t": ["a", "10m", "100m", "1", "2.5"]
        },
      ],
      "locateDevice": true,
      "poePorts": [1, 1, 2],
      "poePower": 0,
      "portTypes": [1, 1, 2],
      "ports": 30,
      "protocol": "unity",
      "radios": [],
      "radiosBandwidth": {},
      "radiosGen": {},
      "tunnelAccess": true
    },
    "wired.port": [
      {
        "portIndex": 1,
        "deviceCategory": "ap",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 2,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 2,
        "deviceCategory": "ap",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 2,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 3,
        "deviceCategory": "ap",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 2,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
    ]
  },
  {
    "seriesName": "DAP-X3060OU/A",
    "capabilities": {
      "locateDevice": true,
      "poePorts": [1, 1, 1, 1, 2],
      "poePower": 0,
      "linkSpeed": [
        {
          "count": 16,
          "t": ["a", "10m", "100m", "1", "2.5"]
        },
      ],
      "portTypes": [1, 1, 2, 2, 2],
      "ports": 30,
      "protocol": "unity",
      "radios": [],
      "radiosBandwidth": {},
      "radiosGen": {},
      "tunnelAccess": true
    },
    "wired.port": [
      {
        "portIndex": 1,
        "deviceCategory": "ap",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 2,
        "deviceCategory": "ap",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 3,
        "deviceCategory": "ap",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 4,
        "deviceCategory": "ap",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 5,
        "deviceCategory": "ap",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
    ]
  },
  {
    "seriesName": "DGS-1100-10MPPV2/A",
    "capabilities": {
      "locateDevice": true,
      "poePorts": [1, 1, 2],
      "poePower": 0,
      "linkSpeed": [
        {
          "count": 16,
          "t": ["a", "10m", "100m", "1", "2.5"]
        },
      ],
      "portTypes": [1, 1, 2],
      "ports": 30,
      "protocol": "unity",
      "radios": [],
      "radiosBandwidth": {},
      "radiosGen": {},
      "tunnelAccess": true
    },
    "wired.port": [
      {
        "portIndex": 1,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 2,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 3,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
    ]
  },
  {
    "seriesName": "DXS-1210-10TS/B",
    "capabilities": {
      "locateDevice": true,
      "poePorts": [1, 1, 2, 2, 2, 2, 2, 2],
      "poePower": 0,
      "linkSpeed": [
        {
          "count": 2,
          "t": ["a", "10m", "100m", "1"]
        },
        {
          "count": 3,
          "t": ["a", "1"]
        },
        {
          "count": 1,
          "t": ["a", "100m", "1", "2.5", "5", "10"],
          "s": ["a", "1", "2.5", "5", "10"],
        },
        {
          "count": 2,
          "t": ["a", "10m", "100m", "1", "2.5", "5", "10", "25"],
          "s": ["a", "1", "2.5", "5", "10", "25"],
        },
      ],
      "locateDevice": true,
      "poePorts": [1, 1, 2, 2, 2, 2, 2, 2],
      "poePower": 0,
      "portTypes": [1, 1, 2, 2, 2, 2, 2, 2],
      "ports": 30,
      "protocol": "unity",
      "radios": [],
      "radiosBandwidth": {},
      "radiosGen": {},
      "tunnelAccess": true
    },
    "wired.port": [
      {
        "portIndex": 1,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 2,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 3,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 4,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 5,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 6,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 7,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 8,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
    ]
  },
  {
    "seriesName": "DXS-1210-16TC/B",
    "capabilities": {
      "locateDevice": true,
      "poePorts": [1, 1, 2],
      "poePower": 0,
      "linkSpeed": [
        {
          "count": 16,
          "t": ["a", "10m", "100m", "1", "2.5"]
        },
      ],
      "locateDevice": true,
      "poePorts": [1, 1, 2],
      "poePower": 0,
      "portTypes": [1, 1, 2],
      "ports": 30,
      "protocol": "unity",
      "radios": [],
      "radiosBandwidth": {},
      "radiosGen": {},
      "tunnelAccess": true
    },
    "wired.port": [
      {
        "portIndex": 1,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 2,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 3,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
    ]
  },
  {
    "seriesName": "DGS-1250-28XMP/F",
    "capabilities": {
      "locateDevice": true,
      "poePorts": [1, 1, 2],
      "poePower": 0,
      "linkSpeed": [
        {
          "count": 16,
          "t": ["a", "10m", "100m", "1", "2.5"]
        },
      ],
      "portTypes": [1, 1, 2],
      "ports": 30,
      "protocol": "unity",
      "radios": [],
      "radiosBandwidth": {},
      "radiosGen": {},
      "tunnelAccess": true
    },
    "wired.port": [
      {
        "portIndex": 1,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 2,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
      {
        "portIndex": 3,
        "deviceCategory": "switch",
        "portTags": [],
        "portProfile": "",
        "portState": true,
        "portType": "access",
        "PVID": 1,
        "allowVlan": "",
        "poeState": true,
        "operation": {
          "type": "switching",
          "mirrorPort": [],
          "mirrorMode": "",
          "aggregatePort": [],
          "aggregateType": ""
        },
        "speed": "auto",
        "comboSfpSpeed": "auto",
        "ddpState": true,
        "lbdState": true
      },
    ]
  },
]

export const defaultConfigProvisioningsSlice = createSlice({
  name: "defaultConfigProvisionings",
  initialState: {
    resource: "defaultConfigProvisionings",
    data: defaultConfigProvisionings
  },
  reducers: {
    getDefaultConfigProvisioningsByModel: (state, action) => {
      const payloadSeriesName = action?.payload?.data?.seriesName || action?.payload?.seriesName || null;
      const matchedConfig = defaultConfigProvisionings.find(defaultConfig => defaultConfig.seriesName === payloadSeriesName);
      state.data = matchedConfig;
    },
  },
});

export const {
  getDefaultConfigProvisioningsByModel
} = defaultConfigProvisioningsSlice.actions;

export default defaultConfigProvisioningsSlice.reducer;
